<template>
  <v-card variant="text" class="mt-4 mx-auto">
    <v-card-actions class="d-flex align-center">
      <div class="mb-6">{{ $t('app.Labels.SelectVisitPlace') }}</div>
      <v-radio-group v-model="selectedOption" inline>
        <v-radio
          v-for="lugar in lugaresVisita"
          :key="lugar.id"
          :label="$t(lugar.descripcionKey)"
          :value="lugar"
        />
      </v-radio-group>
      <v-spacer></v-spacer>
      <v-btn color="success" variant="flat" :disabled="!selectedOption" @click="next">
        {{ $t('app.Buttons.Next') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'DatosLugarVisita',
  data() {
    return {
      selectedOption: null,
    };
  },
  computed: {
    lugaresVisita() {
      return this.$store.state.lugares_visita;
    },
  },
  methods: {
    async next() {
      this.$store.commit('SET_LUGAR_VISITA', this.selectedOption.id);
      if (this.selectedOption.valor === 'megacentro') {
        await this.$store.dispatch('guardarFormulario');
        this.$router.push('/megacentro');
      } else {
        this.$store.commit('SET_VENTANA', 4);
      }
    },
  },
  created() {
    this.$store.dispatch('fetchLugaresVisita');
  },
};
</script>
